export default function IconClose({width="10.63"}) {
    return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 10.63 10.63">
        <path id="close" d="M5-9.875a1.064,1.064,0,0,0,0-1.5,1.064,1.064,0,0,0-1.5,0L0-7.879l-3.5-3.5a1.064,1.064,0,0,0-1.5,0,1.064,1.064,0,0,0,0,1.5l3.5,3.5L-5-2.875a1.064,1.064,0,0,0,0,1.5a1.064,1.064,0,0,0,1.5,0L0-4.871l3.5,3.5a1.064,1.064,0,0,0,1.5,0,1.064,1.064,0,0,0,0-1.5l-3.5-3.5L5-9.875Z" transform="translate(5.315 11.69)" fill="#fff"/>
    </svg>
}
